module.exports = __webpack_public_path__ + "media/images/home-icon-b6c6b165c60fe8330f9ec996ae21c832.svg";